/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Creation_Finalized_TooltipInputs */

const en_task_creation_finalized_tooltip = /** @type {(inputs: Task_Creation_Finalized_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activities cannot be added to a finalized case.`)
};

const pt_br2_task_creation_finalized_tooltip = /** @type {(inputs: Task_Creation_Finalized_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não é possível adicionar atividades a um caso finalizado.`)
};

/**
* | output |
* | --- |
* | "Activities cannot be added to a finalized case." |
*
* @param {Task_Creation_Finalized_TooltipInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_creation_finalized_tooltip = /** @type {((inputs?: Task_Creation_Finalized_TooltipInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Creation_Finalized_TooltipInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_creation_finalized_tooltip(inputs)
	return pt_br2_task_creation_finalized_tooltip(inputs)
});